const isAutoSuggestPopulated = (component) => {
  return component.props.autoSuggestEndpoints
  && Object.keys(component.props.autoSuggestEndpoints).length !== 0 &&
  component.props.autoSuggestEndpoints.constructor === Object
};

export default isAutoSuggestPopulated;